import { render, staticRenderFns } from "./BedVacantDetail.vue?vue&type=template&id=aa0f5c1c&"
import script from "./BedVacantDetail.vue?vue&type=script&lang=js&"
export * from "./BedVacantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports